// extracted by mini-css-extract-plugin
module.exports = {"articleHeader":"styles_articleHeader__MMDOn","title":"styles_title__3sdoh"};